import { CheckedChangedEventHandler } from '@sunwebgroup/ui-components'
import { Accordion } from '@sunwebgroup/ui-components/uds'
import { equals, isEmpty, reject } from 'ramda'
import { useIntl } from '@/intl'
import { ShowMore } from '@/scopes/common/components/ShowMoreUDS'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createSearchFilterClickEvent } from '@/scopes/search/search/domain/analytics'
import { useMultiSelectFilter } from '../../../../domain/hooks'
import { FilterGroupProps } from '../types'
import ListFilterItem from './ListFilterItem'

export function CampaignsAndDiscountsFilter({ defaultOpen }: FilterGroupProps) {
  const intl = useIntl()
  const { sendEvent } = useAnalytics()
  const {
    options,
    selectedValues,
    setSelection,
    isFetching,
  } = useMultiSelectFilter('CampaignsAndDiscounts')

  const handleFilterChange: CheckedChangedEventHandler = ({ checked, value }) => {
    if (checked) {
      setSelection([...selectedValues, value])
      sendEvent(
        createSearchFilterClickEvent({
          element: 'checkbox',
          type: 'campaigns and discounts',
          result: [...selectedValues, value].join(','),
        }),
      )
    }
    if (!checked) {
      setSelection(reject(equals(value), selectedValues))
    }
  }

  if (isEmpty(options))
    return null

  return (
    <Accordion.Item title={intl.formatMessage({ id: 'deals_label' })} defaultOpen={selectedValues.length > 0 || defaultOpen} data-qa="campaigns-and-discounts-filter">
      <ShowMore
        openLabel={intl.formatMessage({ id: 'show_more' })}
        closeLabel={intl.formatMessage({ id: 'show_less' })}
      >
        {options.map(({ name, value, resultsCount }) => (
          <ListFilterItem.Checkbox
            key={name}
            label={name}
            counter={resultsCount}
            checked={selectedValues.includes(value)}
            value={value}
            onChange={handleFilterChange}
            disabled={isFetching}
            data-qa="campaigns-and-discounts-filter-option"
            data-qa-value={value?.toLowerCase()}
          />
        ))}
      </ShowMore>
    </Accordion.Item>
  )
}
